var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[(_vm.from.route)?[_c('add-place',{attrs:{"place":_vm.place}})]:[_c('route-place',{attrs:{"place":_vm.place}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }